// Generated by Melange


function endpoint(base, id, param) {
  const baseUri = "/api/v1/" + base;
  if (id === undefined) {
    return baseUri;
  }
  const id$1 = String(id);
  return "" + baseUri + "/" + id$1;
}

function resource(base, org, id, param) {
  const org$1 = String(org);
  const baseUri = "/api/v1/orgs/" + org$1 + "/" + base;
  if (id === undefined) {
    return baseUri;
  }
  const id$1 = String(id);
  return "" + baseUri + "/" + id$1;
}

function tickets(id, param) {
  const baseUri = "/api/v1/crm/tickets";
  if (id === undefined) {
    return baseUri;
  }
  const id$1 = String(id);
  return "" + baseUri + "/" + id$1;
}

function orgs(id, param) {
  const baseUri = "/api/v1/crm/orgs";
  if (id === undefined) {
    return baseUri;
  }
  const id$1 = String(id);
  return "" + baseUri + "/" + id$1;
}

function orgTickets(org, id, param) {
  const baseUri = "/api/v1/orgs/" + org + "/crm/tickets";
  if (id === undefined) {
    return baseUri;
  }
  const id$1 = String(id);
  return "" + baseUri + "/" + id$1;
}

const Crm = {
  tickets: tickets,
  orgs: orgs,
  orgTickets: orgTickets
};

function items(param, param$1, param$2) {
  return resource("items", param, param$1, param$2);
}

function warehouses(param, param$1, param$2) {
  return resource("sklad/warehouses", param, param$1, param$2);
}

function kkms(param, param$1, param$2) {
  return resource("kassa/kkms", param, param$1, param$2);
}

function reports(param, param$1, param$2) {
  return resource("kassa/reports", param, param$1, param$2);
}

function sales(param, param$1, param$2) {
  return resource("kassa/sales", param, param$1, param$2);
}

const Kassa = {
  kkms: kkms,
  reports: reports,
  sales: sales
};

const Endpoints = {
  endpoint: endpoint,
  resource: resource,
  Crm: Crm,
  items: items,
  warehouses: warehouses,
  Kassa: Kassa
};

export {
  Endpoints,
}
/* No side effect */
